<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-06 13:52:29
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-08-12 11:06:46
 * @Description: 显示列表
-->
<template>
  <div>
    <div class="choosedAddress">
      <div
        class="address-list"
        v-if="addressList.length > 0"
        :class="{ hideMore: !showAllAddressList }"
      >
        <template v-for="(item, index) in addressList">
          <div
            class="item"
            :class="{
              active: userAddressId === item.userAddressId
            }"
            :key="item.userAddressId"
            v-if="showAllAddressList || userAddressId === item.userAddressId"
            @click="chooseAddress(index)"
          >
            {{ item.receiveGoodsPerson }}
            {{ item.receiveGoodsPhone }}
            {{ item.province }}
            {{ item.city }}
            {{ item.area }}
            {{ item.address }}
            <div class="select-icon">
              <i class="triangle"></i>
              <i class="el-icon-check"></i>
            </div>
          </div>
        </template>
      </div>
      <div class="no-address" v-else>
        {{$t('order.emptyAddress')}}
      </div>
      <div>
        <el-button
          type="text"
          class="add-btn"
          v-if="userAddressId"
          @click.stop="clickEdit"
          size="small"
        >
          {{$t('order.updateAddress')}}
        </el-button>
        <el-button
          type="text"
          class="add-btn"
          @click.stop="clickAdd"
          size="small"
        >
          <i class="el-icon-plus"></i> {{$t('order.newAddress')}}
        </el-button>
      </div>
    </div>
    <!-- 显示下拉 -->
    <el-button
      v-if="addressList.length > 0"
      type="text"
      @click="showAllAddressList = !showAllAddressList"
    >
      {{ showAllAddressList ? $t('common.collapse') : $t('common.open') }}
      <i v-if="showAllAddressList" class="el-icon-arrow-up el-icon--right"></i
      ><i v-else class="el-icon-arrow-down el-icon--right"></i
    ></el-button>
    <el-dialog
      :title="$t('order.address')"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      width="580px"
    >
      <AddressAdd
        @handleClose="dialogVisible = false"
        @success="addressAddSuccess"
        v-if="dialogVisible"
        :detail="detail"
      />
    </el-dialog>
  </div>
</template>

<script>
import AddressAdd from './add'
export default {
  components: {
    AddressAdd
  },
  props: {
    addressId: {
      type: String,
      default: ''
    },
    showMore: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showAllAddressList: false,
      dialogVisible: false,
      addressList: [],
      userAddressId: '',
      detail: null
    }
  },
  created () {
    if (this.addressId) {
      this.userAddressId = this.addressId
    }
    this.showAllAddressList = this.showMore
    // 获取地址列表
    this.getAddressList()
  },
  methods: {
    // 切换地址
    chooseAddress (index) {
      let userAddressId = this.addressList[index].userAddressId
      this.userAddressId = userAddressId
      this.showAllAddressList = false
      this.$emit('chooseAddress', userAddressId)
    },
    // 新增地址
    clickAdd () {
      this.detail = null
      this.dialogVisible = true
    },
    // 编辑地址
    clickEdit () {
      this.addressList.some((item) => {
        if (item.userAddressId === this.userAddressId) {
          console.log(item)
          this.detail = item
          return true
        }
        return false
      })
      this.dialogVisible = true
    },
    // 获取地址列表
    getAddressList () {
      return new Promise((resolve, reject) => {
        this.addressList = []
        this.$http
          .get(`/front/consumer/user/address/userAddressList`, {
            params: {
              companyId: this.$store.state.user.defaultCompanyId
            }
          })
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.addressList = res.data || []
              if (this.addressList.length === 0) {
                // 如果是编辑没有地址了 给提示
                if (this.isEdit) {
                  this.userAddressId = ''
                  this.$emit('chooseAddress', this.userAddressId)
                }
                return
              }
              // 如果是编辑
              if (this.isEdit) {
                const t = res.data.some((item) => {
                  if (item.userAddressId === this.userAddressId) {
                    return true
                  }
                  return false
                })
                if (!t) {
                  this.userAddressId = ''
                  this.$emit('chooseAddress', this.userAddressId)
                }
              } else {
                // 新增的时候
                if (this.userAddressId) {
                  return
                }
                // 取默认地址
                res.data.some((item) => {
                  if (item.defaultAddress) {
                    this.userAddressId = item.userAddressId
                    return true
                  }
                  return false
                })
                // 没有默认地址取第0个
                if (!this.userAddressId) {
                  this.userAddressId = this.addressList[0].userAddressId
                }
                this.$emit('chooseAddress', this.userAddressId)
              }
            } else {
              this.$message.error(res.msg || '获取地址失败')
            }
          })
          .catch(() => {})
      })
    },
    // 新增地址成功
    addressAddSuccess () {
      this.getAddressList()
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.choosedAddress {
  display: flex;
  align-items: flex-start;
  .add-btn {
    margin-left: 12px;
  }
}

.address-list {
  border: 1px solid #cacaca;
  max-height: 152px;
  overflow: auto;
  padding: 1px 0 0 0;
  width: 600px;
  .item {
    position: relative;
    margin-top: -1px;
    padding: 0 23px 0 12px;
    line-height: 40px;
    color: #666;
    border: 1px solid transparent;
    cursor: pointer;

    .select-icon {
      position: absolute;
      bottom: 0;
      right: 0;
      display: none;
      width: 23px;
      height: 20px;
    }

    .triangle {
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 0;
      border-top: 20px solid #fff;
      border-right: 23px solid transparent;
    }

    &.active,
    &:hover {
      color: #333;
      border-color: #1d65a8;
      .select-icon {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        background: #1d65a8;
        color: #fff;
      }
    }
  }
  &.hideMore {
    border-color: transparent;
    .item {
      padding-left: 0;
      border-color: transparent;
      cursor: default;
      .select-icon {
        display: none;
      }
    }
  }
}
.no-address {
  color: #606266;
}
</style>
